"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heights = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var sizes = {
    xs: {
        fontSize: 9,
        height: 16,
    },
    sm: {
        fontSize: 10,
        height: 18,
    },
    md: {
        fontSize: 11,
        height: 20,
    },
    lg: {
        fontSize: 13,
        height: 26,
    },
    xl: {
        fontSize: 16,
        height: 32,
    },
};
exports.heights = Object.keys(sizes).reduce(function (acc, key) {
    acc[key] = sizes[key].height;
    return acc;
}, {});
exports.default = react_jss_1.createUseStyles({
    leftSection: function (_a) {
        var theme = _a.theme;
        return ({
            marginRight: theme.spacing.xs / 2,
        });
    },
    rightSection: function (_a) {
        var theme = _a.theme;
        return ({
            marginLeft: theme.spacing.xs / 2,
        });
    },
    inner: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    badge: function (_a) {
        var theme = _a.theme, size = _a.size, fullWidth = _a.fullWidth, radius = _a.radius;
        var _b = size in sizes ? sizes[size] : sizes.md, fontSize = _b.fontSize, height = _b.height;
        return __assign(__assign(__assign({}, theme_1.getFocusStyles(theme)), theme_1.getFontStyles(theme)), { fontSize: fontSize,
            height: height, WebkitTapHighlightColor: 'transparent', lineHeight: height - 2 + "px", border: '1px solid transparent', textDecoration: 'none', padding: [0, theme_1.getSizeValue({ size: size, sizes: theme.spacing }) / 1.5], boxSizing: 'border-box', display: fullWidth ? 'flex' : 'inline-flex', alignItems: 'center', justifyContent: 'center', width: fullWidth ? '100%' : 'auto', textTransform: 'uppercase', borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }), fontWeight: 700, letterSpacing: 0.25, cursor: 'default', textOverflow: 'ellipsis', overflow: 'hidden' });
    },
    light: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 3 : 0 }),
            color: theme.colorScheme === 'dark'
                ? theme.colors.dark[9]
                : theme_1.getThemeColor({ theme: theme, color: color, shade: 9 }),
        });
    },
    filled: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 7 }),
            color: theme.white,
            textShadow: "1px 1px 0 " + theme_1.getThemeColor({ theme: theme, color: color, shade: 9 }),
        });
    },
    outline: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            backgroundColor: 'transparent',
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            borderColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
        });
    },
}, { link: true });
